import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../../data/content';
import { CtaBlock } from '../CtaBlock';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="w-full bg-ink-950 px-4 py-14 sm:py-20" data-id="element-85" data-mp="x53amt4m5r7k">
      <div className="mx-auto max-w-2xl" data-id="element-86" data-mp="1223kzg8hxg4h">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.25em] text-spark-500" data-id="element-87" data-mp="122vfenqcx7t6">
          Réponses claires
        </p>
        <h2 className="mt-3 text-center font-display text-3xl font-bold uppercase leading-tight text-white sm:text-4xl" data-id="element-88" data-mp="1ur0x11m46gos">
          Questions Fréquentes
        </h2>

        <div className="mt-8 space-y-2.5" data-id="element-89" data-mp="1g0bl1x0twxjv">
          {faqs.map((item, i) => {
          const isOpen = open === i;
          return <div key={item.question} className="overflow-hidden rounded-xl border border-white/10 bg-ink-800/60" data-id="element-90" data-mp="28qjyjbkf6ts4" data-mpi={i}>
                <h3 data-id="element-91" data-mp="2djmsvlx0u79d">
                  <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-4 text-left" data-id="element-92" data-mp="2opz28zp9k660">
                    <span className="text-[15px] font-bold leading-snug text-white" data-id="element-93" data-mp="2tpbpvmnylh9n">
                      {item.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-arc-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-94" data-mp="37ff4pskie8p2" />
                  </button>
                </h3>
                {isOpen && <p className="px-4 pb-4 text-sm leading-relaxed text-white/65" data-id="element-95" data-mp="1n0looaegq8jh">
                    {item.answer}
                  </p>}
              </div>;
        })}
        </div>

        <div className="mt-9" data-id="element-96" data-mp="27qpj6hfm7fj5">
          <CtaBlock label="J’ai compris, je commence" data-id="element-97" data-mp="27riiixc8v2r9" />
        </div>
      </div>
    </section>;
}